module.exports = require("brace/ext/searchbox");